import {useEffect, useState} from "react";
import useAxiosPrivate from "../useAxiosPrivate/useAxiosPrivate";
import {axiosPostFormationTemplate} from "../../../Api/ApiFiles/axiosPostFormationTemplate";

function useOnSetSelectedTemplate(auth, docId, templateId, activeDocSetLoadingOrderTable, selectedBol, selectedMan) {

    const axiosPrivate = useAxiosPrivate();
    const [isLinkTemplate, setLinkTemplate] = useState({});

    useEffect(() => {

        let isLoading = true;

        if ((activeDocSetLoadingOrderTable === false && auth?.roles[0] === 'CAPTAIN')
            || (activeDocSetLoadingOrderTable === false && auth?.roles[0] === 'FORWARDER')
            || (activeDocSetLoadingOrderTable === false && auth?.roles[0] === 'USER')
            || (activeDocSetLoadingOrderTable === false && auth?.roles[0] === 'CUSTOM')) {
            if (docId !== undefined && templateId !== undefined) {
                isLoading && axiosPostFormationTemplate(axiosPrivate, docId, templateId, setLinkTemplate)
            }
        } else if((selectedBol !== undefined && auth?.roles[0] === 'CAPTAIN')
            || (selectedBol !== undefined && auth?.roles[0] === 'FORWARDER')
            || (selectedBol !== undefined && auth?.roles[0] === 'USER')
            || (selectedBol !== undefined && auth?.roles[0] === 'CUSTOM')) {
            if (docId !== undefined && templateId !== undefined) {
                isLoading && axiosPostFormationTemplate(axiosPrivate, docId, templateId, setLinkTemplate)
            }
        } else if((selectedMan !== undefined && auth?.roles[0] === 'CAPTAIN')
            || (selectedMan !== undefined && auth?.roles[0] === 'FORWARDER')
            || (selectedMan !== undefined && auth?.roles[0] === 'USER')
            || (selectedMan !== undefined && auth?.roles[0] === 'CUSTOM')) {
            if (docId !== undefined && templateId !== undefined) {
                isLoading && axiosPostFormationTemplate(axiosPrivate, docId, templateId, setLinkTemplate)
            }
        }

        return () => {
            isLoading = false;
        }

    }, [docId, templateId, activeDocSetLoadingOrderTable, selectedBol, selectedMan]);

    return { isLinkTemplate };
}

export default useOnSetSelectedTemplate;
